<template>
  <v-container class="px-0 my-3">
    <v-row>
      <v-col class="v-col-12 px-6 px-lg-0">
        <div class="w-100 bg-white pa-5 position-relative" v-if="loadingProduct && product == null">
          <v-row>
            <v-col class="v-col-12 v-col-lg-7 position-relative">
              <v-skeleton-loader type="image" width="100%" height="400px"></v-skeleton-loader>
            </v-col>
            <v-col class="v-col-12 v-col-lg-5">
              <v-skeleton-loader type="heading, text, text" width="100%"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <div class="w-100 bg-white pa-5 position-relative br-top-5" v-else-if="product != null">
          <v-breadcrumbs class="pa-0">
            <v-breadcrumbs-item class="text-color-0 cursor-pointer" @click="$router.push('/')">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0 cursor-pointer" v-if="categoria != null" @click="$router.push('/feed/'+product.catid)">{{ categoria.name }}</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1 d-none d-lg-block" v-if="categoria != null"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-1 font-weight-bold d-none d-lg-block">{{ product.name }}</v-breadcrumbs-item>
          </v-breadcrumbs>
          <div class="product-like-details cursor-pointer">
            <div v-if="product.offer != null && product.offer.share_link != undefined && product.offer.share_link != ''" @click="share()">
              <Svgs :icon="'whatsapp'" :color="'fill-color-green'" :width="30" :height="30"></Svgs>
            </div>
            <div class="ms-2" v-if="isLiked" @click.stop="removeLike()">
              <Svgs :icon="'coracao-fill'" :color="'fill-color-red'" :width="30" :height="30"></Svgs>
            </div>
            <div class="ms-2" v-else @click.stop="setLike()">
              <Svgs :icon="'coracao'" :color="'fill-color-0'" :width="30" :height="30"></Svgs>
            </div>
          </div>
          <v-row class="mt-2">
            <v-col class="v-col-12 v-col-lg-6 position-relative">
              <v-row>
                <v-col class="v-col-12">
                  <ImageProduct :image="product.image"></ImageProduct>
                </v-col>
                <v-col v-for="(extraimage, index) in extraimages" :key="index" class="v-col-3 cursor-pointer">
                  <ImageProduct :image="extraimage" @click="changeImage(extraimage)"></ImageProduct>
                </v-col>
              </v-row>
              <div class="product-discount-details" v-if="product.offer != null && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0) && (parseFloat(100 - (product.offer.offer_connect * 100 / product.offer.offer_price)) > 1)">
                <b>-{{ parseFloat(100 - (product.offer.offer_connect * 100 / product.offer.offer_price)).toFixed(0) }}%</b>
              </div>
              <div class="product-discount-details-offer" v-if="product.offer != null && (product.offer.offer_connect == 0 || (product.offer.is_offer_unlimited == 0 && product.offer.amount_connect == 0) ) && (parseFloat(100 - (product.offer.offer_price * 100 / product.price)) > 1)">
                <b>-{{ parseFloat(100 - (product.offer.offer_price * 100 / product.price)).toFixed(0) }}%</b>
              </div>
              <div class="product-banner-details" v-if="product.offer != null && product.offer.offer_connect > 0 && product.offer.is_offer_club == 1 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
                <img v-if="product.offer.cluster_id > 0" src="../assets/images/exclusividade_preco-para-vc.png">
                <img v-else src="../assets/images/exclusividade_preco-clube.png">
              </div>
            </v-col>
            <v-col class="v-col-12 v-col-lg-1">
            </v-col>
            <v-col class="v-col-12 v-col-lg-5">
              <div class="product-cashback-details" v-if="product.offer != null && product.offer.cashback > 0">
                <b>CASHBACK ({{ $formatNumber(product.offer.cashback, {style: 'currency', currency: 'BRL'}) }})</b>
              </div>
              <div class="product-title-details">{{ product.name }}</div>
              <div class="product-preco-inicial-details">
                <del v-if="product.offer != null && product.offer.is_offer_club == 1 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">De: {{ $formatNumber(calcPrice(product.offer.offer_price), {style: 'currency', currency: 'BRL'}) }}</del>
                <del v-else-if="product.offer != null && product.price > product.offer.offer_price">De: {{ $formatNumber(calcPrice(product.price), {style: 'currency', currency: 'BRL'}) }}</del>
              </div>
              <div class="product-preco-final-details">
                <span v-if="product.offer != null && product.offer.is_offer_club == 1 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">Por: {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}</span> 
                <span v-else><span v-if="product.offer != null && product.price > product.offer.offer_price">Por:</span> {{ $formatNumber(calcPrice(product.offer != null ? product.offer.offer_price : product.price), {style: 'currency', currency: 'BRL'}) }}</span> 
                <small class="ms-1" v-if="kgund == 1">kg</small><small class="ms-1" v-else>und</small>
              </div>
              <div class="product-kgund-details">
                <div class="product-equivalencia" v-if="product.is_kg == 1 && product.cfg != null && product.cfg.net_weight > 0">
                  Uma unidade é aproximadamente {{ textPesoLiq }}
                </div>
                <div class="product-btn-kgund" v-if="product.is_kg == 1 && product.cfg != null && product.cfg.net_weight > 0">
                  <v-btn-toggle variant="outlined" mandatory @click="changeKgUnd()">
                    <v-btn flat size="x-small" :class="kgund == 0 ? 'bg-color-1 text-white' : ''">
                      <b>und</b>
                    </v-btn>
                    <v-btn flat size="x-small" :class="kgund == 1 ? 'bg-color-1 text-white' : ''">
                      <b>kg</b>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>
              <div class="product-obs-details">
                <span v-if="product.offer != null && product.offer.obs != ''">{{ product.offer.obs }}</span>
              </div>
              <div class="product-oferta-limite-details pt-2 text-center">
                <div v-if="product.offer != null">
                  <span class="text-small" v-if="product.offer.amount_connect > 0 && product.offer.offer_connect > 0">Você tem {{ limiteQtd(product.offer.amount_connect) }} (até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }})</span>
                  <span class="text-small" v-else>Oferta válida até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }}</span>
                </div>
              </div>
              <div class="product-ativacao-details" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
                <v-btn variant="flat" block size="x-large" class="br-5 bg-color-2" @click="activate()" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && product.offer.dh_activated == null">
                  <div class="text-btn-ativacao">
                    ATIVE E PAGUE {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}<br>
                    <small>PREÇO UNIDADE</small>
                  </div>
                </v-btn>
                <v-btn variant="flat" block size="x-large" class="br-5 bg-color-0" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && product.offer.dh_activated != null">
                  <div class="text-btn-ativado">
                    <b v-if="textoCupom == 1">CUPOM ATIVADO</b><b v-else>OFERTA ATIVADA</b> <b>{{ $formatDate(product.offer.dh_activated, { day: '2-digit', month: '2-digit' }) }} {{ $formatTime(product.offer.dh_activated).replace(":", "h") }}</b><br>
                    {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }} <small v-if="kgund == 1">kg</small><small v-else>und</small>
                  </div>
                </v-btn>
              </div>
              <div class="product-btn-details" v-if="product.is_sale">      
                <v-btn variant="outlined" block class="br-5 text-color-2" @click.stop="chooseItem();" v-if="product.offer != null && product.offer.is_offer_family">ESCOLHER</v-btn>
                <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="textQtd" readonly class="text-center border-color-1" v-else-if="item != null && item.cart.amount > 0 && kgund == 1">
                  <template v-slot:prepend-inner>
                    <div @click="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
                      <v-icon icon="mdi-minus"/>
                    </div>
                  </template>
                  <template v-slot:append-inner>
                    <div @click="addItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
                      <v-icon icon="mdi-plus"/>
                    </div>
                  </template>
                </v-text-field>
                <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="qtd" v-maska:[maskqtd] :readonly="product.cfg != null && product.cfg.fractional_amount > 1 ? true: false" @keyup="updateItem()" class="text-center border-color-1" v-else-if="item != null && item.cart.amount > 0 && kgund == 0">
                  <template v-slot:prepend-inner>
                    <div @click="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
                      <v-icon icon="mdi-minus"/>
                    </div>
                  </template>
                  <template v-slot:append-inner>
                    <div @click="addItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
                      <v-icon icon="mdi-plus"/>
                    </div>
                  </template>
                </v-text-field>
                <v-btn variant="outlined" block class="br-5 text-color-2" v-else @click="addItem()">ADICIONAR</v-btn>
              </div>
              <div class="product-btn-details" v-else>
                <v-btn block flat class="br-5 bg-color-0 text-color-white">EXCLUSIVO LOJA FÍSICA</v-btn>
              </div>
              <div v-if="product.offer != null">
                <p class="mt-3 text-color-0 text-small text-justify">
                  <span v-if="$formatDate(product.offer.offer_finish_date+' 00:00:00') == $formatDate(new Date())">Oferta válida apenas para o dia de hoje,&nbsp;</span>
                  <span v-else>Oferta válida até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }}&nbsp;</span>
                  <span v-if="Array.isArray(product.offer.offer_stores)">somente para as unidades {{ product.offer.offer_stores.join(", ") }}.&nbsp;</span>
                  <span v-else>somente para a unidade {{ product.offer.offer_stores }}.&nbsp;</span>
                  <span>Os preços anunciados podem ser alterados sem aviso prévio. Fotos meramente ilustrativas. Salvos erros gráficos e de digitação.</span>
                </p>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="w-100 bg-white pa-5 position-relative mt-5" v-if="product != null && fullproduct != null">
          <v-row>
            <v-col class="v-col-12">
              <h3 class="text-color-1 font-weight-bold mb-3">DETALHES</h3>
              <v-list density="compact">
                <v-list-item class="px-0" v-if="fullproduct.main_name != undefined">
                  <b>{{ fullproduct.main_name }}</b>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.marketing_description != undefined">
                  {{ fullproduct.marketing_description }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.long_description != undefined">
                  <b>Descrição Completa: </b>{{ fullproduct.long_description }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.product_brand != undefined || fullproduct.manufacturer != undefined || fullproduct.origin_country != undefined">
                  <span v-if="fullproduct.product_brand != undefined"><b>Marca: </b>{{ fullproduct.product_brand }}<br></span>
                  <span v-if="fullproduct.manufacturer != undefined"><b>Fabricante: </b>{{ fullproduct.manufacturer }}<br></span>
                  <span v-if="fullproduct.origin_country != undefined"><b>País de Origem: </b>{{ fullproduct.origin_country }}</span>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.ingredients != undefined">
                  <b>Ingredientes: </b>{{ fullproduct.ingredients }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.storage_instructions != undefined || (fullproduct.min_temperature != undefined && fullproduct.min_temperature_unit != undefined) || (fullproduct.max_temperature != undefined && fullproduct.max_temperature_unit != undefined)">
                  <span v-if="fullproduct.storage_instructions != undefined"><b>Armazenamento: </b>{{ fullproduct.storage_instructions }}<br></span>
                  <span v-if="fullproduct.min_temperature != undefined && fullproduct.min_temperature_unit != undefined"><b>Temperatura Mínima: </b>{{ $formatNumber(fullproduct.min_temperature) + " " + fullproduct.min_temperature_unit }}<br></span>
                  <span v-if="fullproduct.max_temperature != undefined && fullproduct.max_temperature_unit != undefined"><b>Temperatura Máxima: </b>{{ $formatNumber(fullproduct.max_temperature) + " " + fullproduct.max_temperature_unit }}<br></span>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.additional_information != undefined">
                  <b>Informações Adicionais: </b>{{ fullproduct.additional_information }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.usage_instructions != undefined">
                  <b>Instruções de Uso: </b>{{ fullproduct.usage_instructions }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.recommendations != undefined">
                  <b>Recomendações: </b>{{ fullproduct.recommendations }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.warning != undefined">
                  <b>Advertência: </b>{{ fullproduct.warning }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.indication != undefined">
                  <b>Indicação: </b>{{ fullproduct.indication }}
                </v-list-item>
                <v-list-item class="px-0" v-if="(fullproduct.gross_weight != undefined && fullproduct.gross_weight_unit != undefined) || (fullproduct.net_weight != undefined && fullproduct.net_weight_unit != undefined)">
                  <span v-if="fullproduct.gross_weight != undefined && fullproduct.gross_weight_unit != undefined"><b>Peso Bruto: </b>{{ $formatNumber(fullproduct.gross_weight) + fullproduct.gross_weight_unit }}<br></span>
                  <span v-if="fullproduct.net_weight != undefined && fullproduct.net_weight_unit != undefined"><b>Peso Líquido: </b>{{ $formatNumber(fullproduct.net_weight) + fullproduct.net_weight_unit }}</span>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.width != undefined && fullproduct.width_unit != undefined && fullproduct.height != undefined && fullproduct.height_unit != undefined && fullproduct.depth != undefined && fullproduct.depth_unit != undefined">
                  <b>Dimensões: </b>{{ $formatNumber(fullproduct.width) + fullproduct.width_unit }} X {{ $formatNumber(fullproduct.height) + fullproduct.height_unit }} X {{ $formatNumber(fullproduct.depth) + fullproduct.depth_unit }}
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.is_inmetro_certified == 1">
                  <b>Certificado Inmetro</b>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.is_toxic == 1">
                  <b>Tóxico</b>
                </v-list-item>
                <v-list-item class="px-0" v-if="fullproduct.is_economical == 1">
                  <b>Embalagem Econômica</b>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </div>
        <div class="w-100 bg-white pa-5 position-relative mt-5" v-if="product != null && infonutri != null">
          <v-row>
            <v-col class="v-col-12">
              <h3 class="text-color-1 font-weight-bold mb-3">INFORMAÇÕES NUTRICIONAIS</h3>
            </v-col>
            <v-col class="v-col-12 v-col-lg-6">
              <span v-if="infonutri.serving_size != undefined && infonutri.serving_unit != undefined"><b>Porção:</b> {{ infonutri.serving_size + infonutri.serving_unit }}</span>
              <span v-if="infonutri.equivalent_serving != undefined"><br><b>Equivalente a:</b> {{ infonutri.equivalent_serving }}</span>
              <v-table v-if="infonutri.itens != null" density="compact">
                <thead>
                  <tr>
                    <th class="text-center">
                      
                    </th>
                    <th class="text-center">
                      Qtd por Porção
                    </th>
                    <th class="text-center">
                      VD
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in infonutri.itens" :key="index">
                    <td>
                      {{ item.label }}
                    </td>
                    <td class="text-end">
                      {{ $formatNumber(item.value) + item.unit }}
                    </td>
                    <td class="text-end">
                      {{ $formatNumber(item.daily_value_percentage) }}%
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <br>
              {{ infonutri.daily_value_reference }}
            </v-col>
            <v-col class="v-col-12 v-col-lg-6">
              <v-list density="compact">
                <v-list-item v-if="infonutri.high_in != null">
                  <b>Alto em:</b> {{ infonutri.high_in }}
                </v-list-item>
                <v-list-item v-if="infonutri.flavoring != null">
                  <b>Aromatizante:</b> {{ infonutri.flavoring }}
                </v-list-item>
                <v-list-item v-if="infonutri.coloring != null">
                  <b>Corante:</b> {{ infonutri.coloring }}
                </v-list-item>
                <v-list-item v-if="infonutri.is_lactose == 1">
                  Contém Lactose
                </v-list-item>
                <v-list-item v-if="infonutri.is_gluten == 1">
                  Contém Glúten
                </v-list-item>
                <v-list-item v-if="infonutri.is_preservatives == 1">
                  Contém Conservantes
                </v-list-item>
                <v-list-item v-if="infonutri.is_light == 1">
                  Light
                </v-list-item>
                <v-list-item v-if="infonutri.is_diet == 1">
                  Diet
                </v-list-item>
                <v-list-item v-if="infonutri.is_whole == 1">
                  Integral
                </v-list-item>
                <v-list-item v-if="infonutri.is_vegan == 1">
                  Vegano
                </v-list-item>
                <v-list-item v-if="infonutri.is_vegetarian == 1">
                  Vegetariano
                </v-list-item>
                <v-list-item v-if="infonutri.is_organic == 1">
                  Orgânico
                </v-list-item>
                <v-list-item v-if="infonutri.is_no_added_sugar == 1">
                  Sem Adição de Açucar
                </v-list-item>
                <v-list-item v-if="infonutri.is_pasteurized == 1">
                  Pasteurizado
                </v-list-item>
                <v-list-item v-if="infonutri.is_low_calorie == 1">
                  Baixa Caloria
                </v-list-item>
                <v-list-item v-if="infonutri.is_skimmed == 1">
                  Desnatado
                </v-list-item>
                <v-list-item v-if="infonutri.is_semi_skimmed == 1">
                  Semidesnatado
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </div>
        <CarouselRelated :barcode="product.barcode" v-if="product != null"></CarouselRelated>
      </v-col>
    </v-row>
  </v-container>
  <DialogFamily :fechar="fechar" :model="modelFamily" :produto="product"></DialogFamily>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ImageProduct from '@/components/ImageProduct.vue';
import DialogFamily from '@/components/DialogFamily.vue';
import Svgs from '@/components/Svgs.vue';
import CarouselRelated from "@/components/CarouselRelated.vue";
export default {
  name: 'Detalhes',
  components: {
    ImageProduct,
    Svgs,
    DialogFamily,
    CarouselRelated
  },
  data(){
    return {
      mobile: true,
      textoCupom: import.meta.env.VITE_IS_TEXTO_ATIVE_O_CUPOM,
      product: null,
      isLiked: false,
      kgund: 0,
      categoria: null,
      qtd: 0,
      qtd_buffer: 0,
      modelFamily: false,
      maskqtd: {
        mask: "####",
      },
      fullproduct: null,
      infonutri: null,
      extraimages: []
    }
  },
  computed: {
    ...mapGetters('main', {
      getCategoryById: 'getCategoryById',
      getConfig: 'getConfig'
    }),
    ...mapGetters('products', {
      getProdutoByBarcode: 'getProdutoByBarcode',
      getLikeByIdProduto: 'getLikeByIdProduto'
    }),
    ...mapState('products', {
      loadingProduct: 'loadingProduct'
    }),
    ...mapGetters('cart', {
      getItemById: 'getItemById'
    }),
    item: function() {
      let retorno = this.product ? this.getItemById(this.product.sku) : null;
      return retorno ? JSON.parse(JSON.stringify(retorno)) : null;
    },
    textPesoLiq: function () {
      if (this.product.cfg != null && this.product.cfg.net_weight > 0) {
        if (this.product.cfg.net_weight < 1) {
            return parseFloat((this.product.cfg.net_weight * 1000))+'g';
        } else {
            return Number.isInteger(this.product.cfg.net_weight) ? (parseFloat(this.product.cfg.net_weight)+'kg').replace(".", ",") : (parseFloat(this.product.cfg.net_weight).toFixed(3)+'kg').replace(".", ",")
        }
      } else {
        return '';
      }
    },
    textQtd: function () {
      if (this.qtd < 1) {
          return Number(Math.round((this.qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(this.qtd) ? (Number(Math.round((this.qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((this.qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    }
  },
  watch: {
    item(i) {
      this.qtd = i != null ? i.cart.amount : 0;
    },
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    ...mapActions('products', {
      setLikeProduto: 'setLikeProduto',
      removeLikeProduto: 'removeLikeProduto',
      loadFamily: 'loadFamily',
      getProductDetails: 'getProductDetails',
      getImageCarousel: 'getImageCarousel',
      connectActivate: 'connectActivate',
      shareOffer: 'shareOffer',
      getFullProduct: 'getFullProduct',
      getInfoNutri: 'getInfoNutri',
      getExtraImages: 'getExtraImages'
    }),
    ...mapActions('cart', {
      updateItemCart: 'updateItemCart'
    }),
    changeImage(image){
      this.product.image = image;
    },
    share(){
      this.shareOffer({
        sku: this.product.sku,
        offer_id: this.product.offer.offer_id
      });
      let link = 'https://web.whatsapp.com/send/?text=' + encodeURIComponent(this.product.offer.share_link + "\n*"+import.meta.env.VITE_PAGE_TITLE + "*\nPara mais ofertas como essa, baixe o nosso aplicativo e receba as melhores ofertas exclusivas no seu celular!");
      window.open(link);
    },
    limiteQtd: function (qtd) {
      if(this.product.is_kg == 1 && this.kgund == 1){
        if (qtd < 1) {
            return Number(Math.round((qtd * 1000) + 'e0') + 'e-0')+'g';
        } else {
            return Number.isInteger(qtd) ? (Number(Math.round((qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
        }
      } else if(this.product.is_kg == 1 && this.product.cfg != null && this.kgund == 0){
        qtd = qtd / this.product.cfg.net_weight;
        if (qtd == 1) {
          return qtd + " unidade";
        } else {
          return qtd + " unidades";
        }
      } else {
        if (qtd == 1) {
          return qtd + " unidade";
        } else {
          return qtd + " unidades";
        }
      }
    },
    changeKgUnd(){
      if(this.qtd > 0){
        let qtd = 0;
        if(this.product.is_kg == 1 && this.product.cfg != null){
          if (this.kgund == 1) {
            this.qtd_buffer = this.qtd;
            qtd = Number(Math.round((parseFloat(this.qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            qtd = qtd < 1 ? 1 : qtd;
          } else if(this.qtd_buffer > 0){
            qtd = this.qtd_buffer;
            this.qtd_buffer = 0;
          } else {
            qtd = parseFloat(this.qtd) * parseFloat(this.product.cfg.net_weight);
          }
          this.kgund = this.kgund == 1 ? 0 : 1;
          this.setQtd(qtd);
        }
      } else 
        this.kgund = this.kgund == 1 ? 0 : 1;
    },
    calcPrice(price){
      if (this.product.is_kg == 1 && this.kgund == 0 && this.product.cfg != null && this.product.cfg.net_weight > 0) {
        price = price * this.product.cfg.net_weight;
      }
      return price;
    },
    updateItem(){
      let qtd = this.verifyMinimum(this.qtd, this.qtd);
      this.qtd = qtd;
      this.setQtd(parseFloat(this.qtd));
    },
    setQtd(qtd){
      if(qtd == null){
        qtd = this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
      }
      if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
        this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        this.qtd = this.product.limit_quantity;
      } else {
        this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
          this.qtd_buffer = 0;
          this.emitter.emit('sendCart');
        }.bind(this));
      }
    },
    addItem(add){
      if(add == undefined && this.qtd == 0 && this.product.offer != null && this.product.offer.is_offer_club == 1 && this.product.offer.offer_connect > 0 && this.product.offer.dh_activated == null){
        this.activateAction(true, true);
      }
      if(add == undefined && this.qtd == 0 && this.product.offer != null && this.product.offer.is_offer_club == 0 && this.product.offer.offer_connect > 0 && this.product.offer.dh_activated == null){
        this.emitter.emit('dialogMessage', { title: "Ative e Pague!", message: "Deseja ativar o desconto e economizar?", response: this.activateAction });
      } else {
        let qtd = this.qtd;
        if(qtd == 0){
          qtd = this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
          if(this.product.is_kg == 1 && this.product.cfg.fractional_amount > 0 && this.kgund == 0){
            qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            qtd = qtd < 1 ? 1 : qtd;
            qtd = this.verifyMinimum(qtd, qtd);
          }
        } else {
          let q = (this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1);
          if(this.product.is_kg == 1 && this.product.cfg.fractional_amount > 0 && this.kgund == 0){
            q = Number(Math.round((parseFloat(q) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            q = q < 1 ? 1 : q;
          }
          qtd = parseFloat(qtd) + parseFloat(q);
        }
        if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
          this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        } else {
          this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
            this.qtd_buffer = 0;
            this.emitter.emit('sendCart');
          }.bind(this));
        }
      }
    },
    removeItem(){
      let qtd = this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1;
      if(this.product.is_kg == 1 && this.product.cfg.fractional_amount > 0 && this.kgund == 0){
        qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
        qtd = qtd < 1 ? 1 : qtd;
      }
      qtd = this.verifyMinimum(parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), qtd);
      this.updateItemCart({ item: this.product, qtd: parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), kgund: this.kgund }).then(function (){
        this.qtd_buffer = 0;
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    verifyMinimum(qtd, qtd_nova){
      let qtd_temp = qtd_nova;
      if(this.product.cfg != null){
        if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
          if(qtd < Number(Math.round((this.product.cfg.minimum_amount / this.product.cfg.net_weight) + 'e0') + 'e-0')){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        } else {
          if(qtd < this.product.cfg.minimum_amount){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        }
      }
      return qtd_temp;
    },
    setLike() {
      this.isLiked = true;
      this.setLikeProduto(this.product.sku);
    },
    removeLike(){
      this.isLiked = false;
      this.removeLikeProduto(this.product.sku);
    },
    chooseItem(){
      this.loadFamily(this.product.offer.offer_id).then(function(){
        this.modelFamily = true;
      }.bind(this));
    },
    fechar: function(){
      this.modelFamily = false;
    },
    setProduct(){
      if(this.item && this.item.cart){
        this.qtd = this.item.cart.amount;
        this.kgund = this.item.cart.type_unit;
      } else {
        this.kgund = this.product.is_kg == 1;
      }
      var like = this.getLikeByIdProduto(this.product.sku);
      this.isLiked = like != null ? true: false;
      this.categoria = this.getCategoryById(this.product.catid);
      if(this.product.image == undefined){
        this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
          this.product.image = image;
        }.bind(this));
      }
    },
    activate(){
      this.activateAction(true, true);
    },
    activateAction: function(r, add){
      if(r){
        if(this.getConfig.isu > 0){
          this.connectActivate(this.product, add).then(function (retorno){
            this.product.offer.dh_activated = retorno;
            if(add != true){
              this.addItem(true);
            }
          }.bind(this));
        } else {
          this.emitter.emit('dialogLogin');
        }
      } else {
        this.addItem(true);
      }
    },
    checkLayout() {
      var val = window.innerWidth;
      if (parseFloat(val) < 1280 && this.previouswidth != val) {
        this.previouswidth = window.innerWidth;
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
  },
  mounted(){
    this.checkLayout();
    this.setConfig().then(function(retorno){
      if(retorno){
        window.addEventListener("resize", this.checkLayout);
        this.product = this.getProdutoByBarcode(this.$route['params']['barcode']);
        if(this.product){
          this.product.image = "";
          this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
            this.product.image = image;
          }.bind(this));
          this.setProduct();
          this.getFullProduct({ barcode: this.product.barcode }).then(function(retorno){
            this.fullproduct = retorno;
          }.bind(this));
          this.getInfoNutri({ barcode: this.product.barcode }).then(function(retorno){
            this.infonutri = retorno;
          }.bind(this));
          this.getExtraImages({ barcode: this.product.barcode }).then(function(retorno){
            if(retorno){
              retorno.forEach(item => {
                this.getImageCarousel({ imghash: item.imghash }).then(function(image){
                  this.extraimages.push(image);
                }.bind(this));
              });
            }
          }.bind(this));
        } else {
          this.getProductDetails(this.$route['params']['barcode']).then(function(response){
            if(response){
              this.product = response;
              this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
                this.product.image = image;
              }.bind(this));
              this.setProduct();
              this.getFullProduct({ barcode: this.product.barcode }).then(function(retorno){
                this.fullproduct = retorno;
              }.bind(this));
              this.getInfoNutri({ barcode: this.product.barcode }).then(function(retorno){
                this.infonutri = retorno;
              }.bind(this));
              this.getExtraImages({ barcode: this.product.barcode }).then(function(retorno){
                if(retorno){
                  retorno.forEach(item => {
                    this.getImageCarousel({ imghash: item.imghash }).then(function(image){
                      this.extraimages.push(image);
                    }.bind(this));
                  });
                }
              }.bind(this));
            } else {
              this.$router.push('/');
            }
          }.bind(this));
        }
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name + ( this.product != null ? " - " + this.product.name : "") } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
  unmounted() {
    window.removeEventListener("resize", this.checkLayout);
  },
}
</script>